var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgModaEBeleza = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1002 3.50982C11.0986 3.46329 10.2669 4.25963 10.2669 5.25736H9.26688C9.26688 3.6898 10.5744 2.43786 12.1463 2.51088C13.5498 2.57522 14.6998 3.72466 14.7641 5.12801C14.8169 6.28123 14.1525 7.32651 13.1178 7.77805C12.7528 7.93748 12.5169 8.29684 12.5169 8.69386V9.33257C12.9533 9.45061 13.3524 9.71657 13.6322 10.1159L20.3719 19.7402C21.3929 21.2001 20.1406 23.1658 18.3858 22.8569L2.02245 19.9709C0.2676 19.6619 -0.237025 17.3849 1.22248 16.3636L10.8468 9.62512C11.0558 9.47856 11.2831 9.37762 11.5169 9.32022V8.69386C11.5169 7.89877 11.9887 7.17999 12.7177 6.86159C13.3762 6.57421 13.7988 5.90931 13.7652 5.17375C13.7245 4.28686 12.9878 3.55051 12.1002 3.50982ZM1.79593 17.1828C1.06643 17.6933 1.3187 18.8316 2.196 18.9861L18.5594 21.8721C19.4369 22.0266 20.0631 21.0436 19.5526 20.3135L12.8131 10.6896C12.496 10.237 11.8727 10.1271 11.4207 10.4441L1.79593 17.1828Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgModaEBeleza;